export const getRegionOptions = () => {
  return [
    { value: "AF", label: "🇦🇫  Afghanistan" },
    { value: "AL", label: "🇦🇱  Albania" },
    { value: "DZ", label: "🇩🇿  Algeria" },
    { value: "AS", label: "🇦🇸  American Samoa" },
    { value: "AD", label: "🇦🇩  Andorra" },
    { value: "AO", label: "🇦🇴  Angola" },
    { value: "AI", label: "🇦🇮  Anguilla" },
    { value: "AQ", label: "🇦🇶  Antarctica" },
    { value: "AG", label: "🇦🇬  Antigua and Barbuda" },
    { value: "AR", label: "🇦🇷  Argentina" },
    { value: "AM", label: "🇦🇲  Armenia" },
    { value: "AW", label: "🇦🇼  Aruba" },
    { value: "AX", label: "🇦🇽  Aland Islands", hubspotName: "Åland Islands" },
    { value: "AU", label: "🇦🇺  Australia" },
    { value: "AT", label: "🇦🇹  Austria" },
    { value: "AZ", label: "🇦🇿  Azerbaijan" },
    { value: "BS", label: "🇧🇸  Bahamas" },
    { value: "BH", label: "🇧🇭  Bahrain" },
    { value: "BD", label: "🇧🇩  Bangladesh" },
    { value: "BB", label: "🇧🇧  Barbados" },
    { value: "BY", label: "🇧🇾  Belarus" },
    { value: "BE", label: "🇧🇪  Belgium" },
    { value: "BZ", label: "🇧🇿  Belize" },
    { value: "BJ", label: "🇧🇯  Benin" },
    { value: "BM", label: "🇧🇲  Bermuda" },
    { value: "BT", label: "🇧🇹  Bhutan" },
    { value: "BO", label: "🇧🇴  Bolivia" },
    { value: "BQ", label: "🇧🇶  Bonaire, Sint Eustatius and Saba", hubspotName: "Caribbean Netherlands" },
    { value: "BA", label: "🇧🇦  Bosnia and Herzegovina" },
    { value: "BW", label: "🇧🇼  Botswana" },
    { value: "BV", label: "🇧🇻  Bouvet Island" },
    { value: "BR", label: "🇧🇷  Brazil" },
    { value: "IO", label: "🇮🇴  British Indian Ocean Territory" },
    { value: "BN", label: "🇧🇳  Brunei" },
    { value: "BG", label: "🇧🇬  Bulgaria" },
    { value: "BF", label: "🇧🇫  Burkina Faso" },
    { value: "BI", label: "🇧🇮  Burundi" },
    { value: "KH", label: "🇰🇭  Cambodia" },
    { value: "CM", label: "🇨🇲  Cameroon" },
    { value: "CA", label: "🇨🇦  Canada" },
    { value: "CV", label: "🇨🇻  Cape Verde" },
    { value: "KY", label: "🇰🇾  Cayman Islands" },
    { value: "CF", label: "🇨🇫  Central African Republic" },
    { value: "TD", label: "🇹🇩  Chad" },
    { value: "CL", label: "🇨🇱  Chile" },
    { value: "CN", label: "🇨🇳  China" },
    { value: "CX", label: "🇨🇽  Christmas Island" },
    { value: "CC", label: "🇨🇨  Cocos (Keeling) Islands" },
    { value: "CO", label: "🇨🇴  Colombia" },
    { value: "KM", label: "🇰🇲  Comoros" },
    { value: "CD", label: "🇨🇩  Congo (Democratic Republic)", hubspotName: "Democratic Republic of the Congo" },
    { value: "CG", label: "🇨🇬  Congo (Republic)", hubspotName: "Congo" },
    { value: "CK", label: "🇨🇰  Cook Islands" },
    { value: "CR", label: "🇨🇷  Costa Rica" },
    { value: "HR", label: "🇭🇷  Croatia" },
    { value: "CU", label: "🇨🇺  Cuba" },
    { value: "CW", label: "🇨🇼  Curaçao" },
    { value: "CY", label: "🇨🇾  Cyprus" },
    { value: "CZ", label: "🇨🇿  Czech Republic" },
    { value: "DK", label: "🇩🇰  Denmark" },
    { value: "DJ", label: "🇩🇯  Djibouti" },
    { value: "DM", label: "🇩🇲  Dominica" },
    { value: "DO", label: "🇩🇴  Dominican Republic" },
    { value: "EC", label: "🇪🇨  Ecuador" },
    { value: "EG", label: "🇪🇬  Egypt" },
    { value: "SV", label: "🇸🇻  El Salvador" },
    { value: "GQ", label: "🇬🇶  Equatorial Guinea" },
    { value: "ER", label: "🇪🇷  Eritrea" },
    { value: "EE", label: "🇪🇪  Estonia" },
    { value: "ET", label: "🇪🇹  Ethiopia" },
    { value: "FK", label: "🇫🇰  Falkland Islands (Malvinas)", hubspotName: "Falkland Islands" },
    { value: "FO", label: "🇫🇴  Faroe Islands" },
    { value: "FJ", label: "🇫🇯  Fiji" },
    { value: "FI", label: "🇫🇮  Finland" },
    { value: "FR", label: "🇫🇷  France" },
    { value: "GF", label: "🇬🇫  French Guiana" },
    { value: "PF", label: "🇵🇫  French Polynesia" },
    { value: "TF", label: "🇹🇫  French Southern Territories", hubspotName: "French Southern and Antarctic Lands" },
    { value: "GA", label: "🇬🇦  Gabon" },
    { value: "GM", label: "🇬🇲  Gambia" },
    { value: "GE", label: "🇬🇪  Georgia" },
    { value: "DE", label: "🇩🇪  Germany" },
    { value: "GH", label: "🇬🇭  Ghana" },
    { value: "GI", label: "🇬🇮  Gibraltar" },
    { value: "GR", label: "🇬🇷  Greece" },
    { value: "GL", label: "🇬🇱  Greenland" },
    { value: "GD", label: "🇬🇩  Grenada" },
    { value: "GP", label: "🇬🇵  Guadeloupe" },
    { value: "GU", label: "🇬🇺  Guam" },
    { value: "GT", label: "🇬🇹  Guatemala" },
    { value: "GG", label: "🇬🇬  Guernsey" },
    { value: "GN", label: "🇬🇳  Guinea" },
    { value: "GW", label: "🇬🇼  Guinea-Bissau" },
    { value: "GY", label: "🇬🇾  Guyana" },
    { value: "HT", label: "🇭🇹  Haiti" },
    { value: "HM", label: "🇭🇲  Heard Island and Mcdonald Islands", hubspotName: "Heard Island and McDonald Islands" },
    { value: "HN", label: "🇭🇳  Honduras" },
    { value: "HK", label: "🇭🇰  Hong Kong" },
    { value: "HU", label: "🇭🇺  Hungary" },
    { value: "IS", label: "🇮🇸  Iceland" },
    { value: "IN", label: "🇮🇳  India" },
    { value: "ID", label: "🇮🇩  Indonesia" },
    { value: "IR", label: "🇮🇷  Iran" },
    { value: "IQ", label: "🇮🇶  Iraq" },
    { value: "IE", label: "🇮🇪  Ireland" },
    { value: "IM", label: "🇮🇲  Isle of Man" },
    { value: "IL", label: "🇮🇱  Israel" },
    { value: "IT", label: "🇮🇹  Italy" },
    { value: "CI", label: "🇨🇮  Ivory Coast", hubspotName: "Cote d'Ivoire" },
    { value: "JM", label: "🇯🇲  Jamaica" },
    { value: "JP", label: "🇯🇵  Japan" },
    { value: "JE", label: "🇯🇪  Jersey" },
    { value: "JO", label: "🇯🇴  Jordan" },
    { value: "KZ", label: "🇰🇿  Kazakhstan" },
    { value: "KE", label: "🇰🇪  Kenya" },
    { value: "KI", label: "🇰🇮  Kiribati" },
    { value: "KW", label: "🇰🇼  Kuwait" },
    { value: "KG", label: "🇰🇬  Kyrgyzstan" },
    { value: "XK", label: "🇽🇰 Kosovo" },
    { value: "LA", label: "🇱🇦  Lao People's Democratic Republic", hubspotName: "Laos" },
    { value: "LV", label: "🇱🇻  Latvia" },
    { value: "LB", label: "🇱🇧  Lebanon" },
    { value: "LS", label: "🇱🇸  Lesotho" },
    { value: "LR", label: "🇱🇷  Liberia" },
    { value: "LY", label: "🇱🇾  Libya" },
    { value: "LI", label: "🇱🇮  Liechtenstein" },
    { value: "LT", label: "🇱🇹  Lithuania" },
    { value: "LU", label: "🇱🇺  Luxembourg" },
    { value: "MO", label: "🇲🇴  Macao", hubspotName: "Macau" },
    { value: "MK", label: "🇲🇰  Macedonia", hubspotName: "Macedonia (FYROM)" },
    { value: "MG", label: "🇲🇬  Madagascar" },
    { value: "MW", label: "🇲🇼  Malawi" },
    { value: "MY", label: "🇲🇾  Malaysia" },
    { value: "MV", label: "🇲🇻  Maldives" },
    { value: "ML", label: "🇲🇱  Mali" },
    { value: "MT", label: "🇲🇹  Malta" },
    { value: "MH", label: "🇲🇭  Marshall Islands" },
    { value: "MQ", label: "🇲🇶  Martinique" },
    { value: "MR", label: "🇲🇷  Mauritania" },
    { value: "MU", label: "🇲🇺  Mauritius" },
    { value: "YT", label: "🇾🇹  Mayotte" },
    { value: "MX", label: "🇲🇽  Mexico" },
    { value: "FM", label: "🇫🇲  Micronesia" },
    { value: "MD", label: "🇲🇩  Moldova" },
    { value: "MC", label: "🇲🇨  Monaco" },
    { value: "MN", label: "🇲🇳  Mongolia" },
    { value: "ME", label: "🇲🇪  Montenegro" },
    { value: "MS", label: "🇲🇸  Montserrat" },
    { value: "MA", label: "🇲🇦  Morocco" },
    { value: "MZ", label: "🇲🇿  Mozambique" },
    { value: "MM", label: "🇲🇲  Myanmar", hubspotName: "Myanmar (Burma)" },
    { value: "NA", label: "🇳🇦  Namibia" },
    { value: "NR", label: "🇳🇷  Nauru" },
    { value: "NP", label: "🇳🇵  Nepal" },
    { value: "NL", label: "🇳🇱  Netherlands" },
    { value: "NC", label: "🇳🇨  New Caledonia" },
    { value: "NZ", label: "🇳🇿  New Zealand" },
    { value: "NI", label: "🇳🇮  Nicaragua" },
    { value: "NE", label: "🇳🇪  Niger" },
    { value: "NG", label: "🇳🇬  Nigeria" },
    { value: "NU", label: "🇳🇺  Niue" },
    { value: "NF", label: "🇳🇫  Norfolk Island" },
    { value: "KP", label: "🇰🇵  North Korea" },
    { value: "MP", label: "🇲🇵  Northern Mariana Islands" },
    { value: "NO", label: "🇳🇴  Norway" },
    { value: "OM", label: "🇴🇲  Oman" },
    { value: "PK", label: "🇵🇰  Pakistan" },
    { value: "PW", label: "🇵🇼  Palau" },
    { value: "PS", label: "🇵🇸  Palestinian Territory", hubspotName: "Palestine" },
    { value: "PA", label: "🇵🇦  Panama" },
    { value: "PG", label: "🇵🇬  Papua New Guinea" },
    { value: "PY", label: "🇵🇾  Paraguay" },
    { value: "PE", label: "🇵🇪  Peru" },
    { value: "PH", label: "🇵🇭  Philippines" },
    { value: "PN", label: "🇵🇳  Pitcairn", hubspotName: "Pitcairn Islands" },
    { value: "PL", label: "🇵🇱  Poland" },
    { value: "PT", label: "🇵🇹  Portugal" },
    { value: "PR", label: "🇵🇷  Puerto Rico" },
    { value: "QA", label: "🇶🇦  Qatar" },
    { value: "RE", label: "🇷🇪  Réunion" },
    { value: "RO", label: "🇷🇴  Romania" },
    { value: "RU", label: "🇷🇺  Russia" },
    { value: "RW", label: "🇷🇼  Rwanda" },
    { value: "BL", label: "🇧🇱  Saint Barthélemy" },
    { value: "KN", label: "🇰🇳  Saint Kitts and Nevis" },
    { value: "LC", label: "🇱🇨  Saint Lucia" },
    { value: "MF", label: "🇲🇫  Saint Martin (French Part)", hubspotName: "Saint Martin" },
    { value: "PM", label: "🇵🇲  Saint Pierre and Miquelon" },
    { value: "VC", label: "🇻🇨  Saint Vincent and The Grenadines", hubspotName: "Saint Vincent and the Grenadines" },
    { value: "WS", label: "🇼🇸  Samoa" },
    { value: "SM", label: "🇸🇲  San Marino" },
    { value: "ST", label: "🇸🇹  Sao Tome and Principe" },
    { value: "SA", label: "🇸🇦  Saudi Arabia" },
    { value: "SN", label: "🇸🇳  Senegal" },
    { value: "RS", label: "🇷🇸  Serbia" },
    { value: "SC", label: "🇸🇨  Seychelles" },
    { value: "SL", label: "🇸🇱  Sierra Leone" },
    { value: "SG", label: "🇸🇬  Singapore" },
    { value: "SX", label: "🇸🇽  Sint Maarten (Dutch Part)", hubspotName: "Sint Maarten" },
    { value: "SK", label: "🇸🇰  Slovakia" },
    { value: "SI", label: "🇸🇮  Slovenia" },
    { value: "SB", label: "🇸🇧  Solomon Islands" },
    { value: "SO", label: "🇸🇴  Somalia" },
    { value: "ZA", label: "🇿🇦  South Africa" },
    { value: "GS", label: "🇬🇸  South Georgia", hubspotName: "South Georgia and the South Sandwich Islands" },
    { value: "KR", label: "🇰🇷  South Korea" },
    { value: "SS", label: "🇸🇸  South Sudan" },
    { value: "ES", label: "🇪🇸  Spain" },
    { value: "LK", label: "🇱🇰  Sri Lanka" },
    { value: "SD", label: "🇸🇩  Sudan" },
    { value: "SR", label: "🇸🇷  Suriname" },
    { value: "SJ", label: "🇸🇯  Svalbard and Jan Mayen" },
    { value: "SZ", label: "🇸🇿  Swaziland" },
    { value: "SE", label: "🇸🇪  Sweden" },
    { value: "CH", label: "🇨🇭  Switzerland" },
    { value: "SY", label: "🇸🇾  Syrian Arab Republic", hubspotName: "Syria" },
    { value: "TW", label: "🇹🇼  Taiwan" },
    { value: "TJ", label: "🇹🇯  Tajikistan" },
    { value: "TZ", label: "🇹🇿  Tanzania" },
    { value: "TH", label: "🇹🇭  Thailand" },
    { value: "TL", label: "🇹🇱  Timor-Leste", hubspotName: "East Timor" },
    { value: "TG", label: "🇹🇬  Togo" },
    { value: "TK", label: "🇹🇰  Tokelau" },
    { value: "TO", label: "🇹🇴  Tonga" },
    { value: "TT", label: "🇹🇹  Trinidad and Tobago" },
    { value: "TN", label: "🇹🇳  Tunisia" },
    { value: "TR", label: "🇹🇷  Turkey" },
    { value: "TM", label: "🇹🇲  Turkmenistan" },
    { value: "TC", label: "🇹🇨  Turks and Caicos Islands" },
    { value: "TV", label: "🇹🇻  Tuvalu" },
    { value: "UG", label: "🇺🇬  Uganda" },
    { value: "UA", label: "🇺🇦  Ukraine" },
    { value: "AE", label: "🇦🇪  United Arab Emirates" },
    { value: "GB", label: "🇬🇧  United Kingdom" },
    { value: "US", label: "🇺🇸  United States" },
    { value: "UY", label: "🇺🇾  Uruguay" },
    { value: "UZ", label: "🇺🇿  Uzbekistan" },
    { value: "VU", label: "🇻🇺  Vanuatu" },
    { value: "VA", label: "🇻🇦  Vatican City" },
    { value: "VE", label: "🇻🇪  Venezuela" },
    { value: "VN", label: "🇻🇳  Viet Nam", hubspotName: "Vietnam" },
    { value: "VG", label: "🇻🇬  Virgin Islands, British", hubspotName: "British Virgin Islands" },
    { value: "VI", label: "🇻🇮  Virgin Islands, U.S.", hubspotName: "U.S. Virgin Islands" },
    { value: "WF", label: "🇼🇫  Wallis and Futuna" },
    { value: "EH", label: "🇪🇭  Western Sahara", hubspotName: null },
    { value: "YE", label: "🇾🇪  Yemen" },
    { value: "ZM", label: "🇿🇲  Zambia" },
    { value: "ZW", label: "🇿🇼  Zimbabwe" },
  ];
};
export const getFlagByCountryCode = (countryCode) => {
  const countryFlagEmojis = {
    global: "🌍",
    AF: "🇦🇫",
    AX: "🇦🇽",
    AL: "🇦🇱",
    DZ: "🇩🇿",
    AS: "🇦🇸",
    AD: "🇦🇩",
    AO: "🇦🇴",
    AI: "🇦🇮",
    AQ: "🇦🇶",
    AG: "🇦🇬",
    AR: "🇦🇷",
    AM: "🇦🇲",
    AW: "🇦🇼",
    AU: "🇦🇺",
    AT: "🇦🇹",
    AZ: "🇦🇿",
    BS: "🇧🇸",
    BH: "🇧🇭",
    BD: "🇧🇩",
    BB: "🇧🇧",
    BY: "🇧🇾",
    BE: "🇧🇪",
    BZ: "🇧🇿",
    BJ: "🇧🇯",
    BM: "🇧🇲",
    BT: "🇧🇹",
    BO: "🇧🇴",
    BA: "🇧🇦",
    BW: "🇧🇼",
    BV: "🇧🇻",
    BR: "🇧🇷",
    IO: "🇮🇴",
    BN: "🇧🇳",
    BG: "🇧🇬",
    BF: "🇧🇫",
    BI: "🇧🇮",
    KH: "🇰🇭",
    CM: "🇨🇲",
    CA: "🇨🇦",
    CV: "🇨🇻",
    KY: "🇰🇾",
    CF: "🇨🇫",
    TD: "🇹🇩",
    CL: "🇨🇱",
    CN: "🇨🇳",
    CX: "🇨🇽",
    CC: "🇨🇨",
    CO: "🇨🇴",
    KM: "🇰🇲",
    CG: "🇨🇬",
    CD: "🇨🇩",
    CK: "🇨🇰",
    CR: "🇨🇷",
    CI: "🇨🇮",
    HR: "🇭🇷",
    CU: "🇨🇺",
    CW: "🇨🇼",
    CY: "🇨🇾",
    CZ: "🇨🇿",
    DK: "🇩🇰",
    DJ: "🇩🇯",
    DM: "🇩🇲",
    DO: "🇩🇴",
    EC: "🇪🇨",
    EG: "🇪🇬",
    SV: "🇸🇻",
    GQ: "🇬🇶",
    ER: "🇪🇷",
    EE: "🇪🇪",
    ET: "🇪🇹",
    FK: "🇫🇰",
    FO: "🇫🇴",
    FJ: "🇫🇯",
    FI: "🇫🇮",
    FR: "🇫🇷",
    GF: "🇬🇫",
    PF: "🇵🇫",
    TF: "🇹🇫",
    GA: "🇬🇦",
    GM: "🇬🇲",
    GE: "🇬🇪",
    DE: "🇩🇪",
    GH: "🇬🇭",
    GI: "🇬🇮",
    GR: "🇬🇷",
    GL: "🇬🇱",
    GD: "🇬🇩",
    GP: "🇬🇵",
    GU: "🇬🇺",
    GT: "🇬🇹",
    GG: "🇬🇬",
    GN: "🇬🇳",
    GW: "🇬🇼",
    GY: "🇬🇾",
    HT: "🇭🇹",
    HM: "🇭🇲",
    VA: "🇻🇦",
    HN: "🇭🇳",
    HK: "🇭🇰",
    HU: "🇭🇺",
    IS: "🇮🇸",
    IN: "🇮🇳",
    ID: "🇮🇩",
    IR: "🇮🇷",
    IQ: "🇮🇶",
    IE: "🇮🇪",
    IM: "🇮🇲",
    IL: "🇮🇱",
    IT: "🇮🇹",
    JM: "🇯🇲",
    JP: "🇯🇵",
    JE: "🇯🇪",
    JO: "🇯🇴",
    KZ: "🇰🇿",
    KE: "🇰🇪",
    KI: "🇰🇮",
    KP: "🇰🇵",
    KR: "🇰🇷",
    KW: "🇰🇼",
    KG: "🇰🇬",
    LA: "🇱🇦",
    LV: "🇱🇻",
    LB: "🇱🇧",
    LS: "🇱🇸",
    LR: "🇱🇷",
    LY: "🇱🇾",
    LI: "🇱🇮",
    LT: "🇱🇹",
    LU: "🇱🇺",
    MO: "🇲🇴",
    MK: "🇲🇰",
    MG: "🇲🇬",
    MW: "🇲🇼",
    MY: "🇲🇾",
    MV: "🇲🇻",
    ML: "🇲🇱",
    MT: "🇲🇹",
    MH: "🇲🇭",
    MQ: "🇲🇶",
    MR: "🇲🇷",
    MU: "🇲🇺",
    YT: "🇾🇹",
    MX: "🇲🇽",
    FM: "🇫🇲",
    MD: "🇲🇩",
    MC: "🇲🇨",
    MN: "🇲🇳",
    ME: "🇲🇪",
    MS: "🇲🇸",
    MA: "🇲🇦",
    MZ: "🇲🇿",
    MM: "🇲🇲",
    NA: "🇳🇦",
    NR: "🇳🇷",
    NP: "🇳🇵",
    NL: "🇳🇱",
    NC: "🇳🇨",
    NZ: "🇳🇿",
    NI: "🇳🇮",
    NE: "🇳🇪",
    NG: "🇳🇬",
    NU: "🇳🇺",
    NF: "🇳🇫",
    MP: "🇲🇵",
    NO: "🇳🇴",
    OM: "🇴🇲",
    PK: "🇵🇰",
    PW: "🇵🇼",
    PS: "🇵🇸",
    PA: "🇵🇦",
    PG: "🇵🇬",
    PY: "🇵🇾",
    PE: "🇵🇪",
    PH: "🇵🇭",
    PN: "🇵🇳",
    PL: "🇵🇱",
    PT: "🇵🇹",
    PR: "🇵🇷",
    QA: "🇶🇦",
    RE: "🇷🇪",
    RO: "🇷🇴",
    RU: "🇷🇺",
    RW: "🇷🇼",
    BL: "🇧🇱",
    SH: "🇸🇭",
    KN: "🇰🇳",
    LC: "🇱🇨",
    MF: "🇲🇫",
    PM: "🇵🇲",
    VC: "🇻🇨",
    WS: "🇼🇸",
    SM: "🇸🇲",
    ST: "🇸🇹",
    SA: "🇸🇦",
    SN: "🇸🇳",
    RS: "🇷🇸",
    SC: "🇸🇨",
    SL: "🇸🇱",
    SG: "🇸🇬",
    SX: "🇸🇽",
    SK: "🇸🇰",
    SI: "🇸🇮",
    SB: "🇸🇧",
    SO: "🇸🇴",
    ZA: "🇿🇦",
    GS: "🇸🇬",
    SS: "🇸🇸",
    ES: "🇪🇸",
    LK: "🇱🇰",
    SD: "🇸🇩",
    SR: "🇸🇷",
    SJ: "🇸🇯",
    SZ: "🇸🇿",
    SE: "🇸🇪",
    CH: "🇨🇭",
    SY: "🇸🇾",
    TW: "🇹🇼",
    TJ: "🇹🇯",
    TZ: "🇹🇿",
    TH: "🇹🇭",
    TL: "🇹🇱",
    TG: "🇹🇬",
    TK: "🇹🇰",
    TO: "🇹🇴",
    TT: "🇹🇹",
    TN: "🇹🇳",
    TR: "🇹🇷",
    TM: "🇹🇲",
    TC: "🇹🇨",
    TV: "🇹🇻",
    UG: "🇺🇬",
    UA: "🇺🇦",
    AE: "🇦🇪",
    GB: "🇬🇧",
    US: "🇺🇸",
    UM: "🇺🇲",
    UY: "🇺🇾",
    UZ: "🇺🇿",
    VU: "🇻🇺",
    VE: "🇻🇪",
    VN: "🇻🇳",
    VG: "🇻🇬",
    VI: "🇻🇮",
    WF: "🇼🇫",
    EH: "🇪🇭",
    YE: "🇾🇪",
    ZM: "🇿🇲",
    ZW: "🇿🇼",
  };
  return countryFlagEmojis[countryCode];
};

export const getCountryName = (code) => {
  if (code === "global") return "🌍 Global";
  const country = getRegionOptions().find((c) => c.value === code);
  return country ? country.label : code;
};

export const getCountryHubspotName = (code) => {
  if (code === "global") return "Global";
  const country = getRegionOptions().find((c) => c.value === code);
  if (!country) return code;
  if (country.hubspotName === null) return null;
  return country.hubspotName ?? country.label.match(/[A-Za-zÅ].*/)?.[0]?.trim() ?? code;
};